module.exports = __webpack_public_path__ + "src/assets/lv.50d4bf38.png";